module.exports = __webpack_public_path__ + "img/j3-debt-logo.59667749.png";